import SelectMy, { TSelectMy } from 'components/SelectMy';

// const getOption = (role: string, desk: string) => (
//     <Text color="gray.900" fontSize="16px" fontWeight={400} lineHeight={1} letterSpacing="initial">
//         {role}
//         <Text color="gray.500" as="span">
//             {' '}
//             – {desk}
//         </Text>
//     </Text>
// );

// export const ROLE_OPTIONS = [
//     {
//         label: getOption('Admin', 'Full access with unlimited permissions'),
//         value: ROLES.admin,
//     },
//     {
//         label: getOption('Member', 'Full access with limited permissions'),
//         value: ROLES.member,
//     },
// ];

const UserDropdown = ({ label, value, onChange, sx, options }: TSelectMy) => {
    return <SelectMy sx={sx} value={value} label={label} onChange={onChange} options={options} />;
};

export default UserDropdown;
